/* eslint-disable react-hooks/exhaustive-deps */
import { AddArtista, DivLeft, Ticket, Ospiti, InfoOrganizzatore, BorghiVicini, RispostaAI, ServiziRapidi, OpzioniEvento, Geolocation, DettagliEvento } from './components/eventiDetails'
import { NavbarNotAuth, App, AutoNoleggio, DivBottom, Ristoranti, Alberghi, AltriEventiRegione, Fornitori, Luoghi, Commenti } from './components'
import { CollabArtisti } from '../userAuth/components'
import { NavbarBottomAdmin, NavbarTopAdmin } from '../admin/components'
import { useParams, useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import axios from 'axios'
import { useState, useEffect, useRef } from 'react'
import { useLoadScript } from '@react-google-maps/api'
import { RotatingLines } from "react-loader-spinner"
import 'react-quill-new/dist/quill.snow.css'

const LIBRARIES = ['places'] // per google maps
const idUser = localStorage.getItem('id'); const logged = localStorage.getItem('logged')

function EventiDetails() {
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const bannerCorrente = searchParams.get('banner')

    const { isLoaded, loadError } = useLoadScript({ // COSTRUTTORE GOOGLE MAPS
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS,
        LIBRARIES // Aggiungi libraries se necessario
    })
    const { id } = useParams()//id evento per dettagli
    const fotoRandom = location.state?.fotoScelta || ''

    const [evento, setEvento] = useState({})
    const [img, setImg] = useState([])
    const [opaco, setOpaco] = useState(1)//opacity per eventi annullati
    const [prefer, setPrefer] = useState('')//contenuto del testo accanto al cuore
    const [center, setCenter] = useState({ lat: '', lng: '', distanza: 10000 })
    const [gestDescr, setGestDescr] = useState({ testoTagliato: null, restoDelTesto: null })
    const [commentiLength, setCommentiLength] = useState(0)
    const [incorpora, setIncorpora] = useState(null)
    const [tipo, setTipo] = useState(null)
    const [domandaAI, setDomandaAI] = useState(null)

    const preferitiCuore = useRef()//per dinamica a icona cuore
    const preferitiTesto = useRef()//per dinamica a testo accanto al cuore
    const parSottotitolo = useRef() //per lampeggio sottotitolo
    const maps = useRef(null)// per scrollare fino a google maps

    const regioni =
    {
        Abruzzo: "Natura selvaggia, mare e borghi autentici", Campania: "La regione con la sua tradizione gastronomica", EmiliaRomagna: "La regione Ospitale, Squisita, Veloce",
        FriuliVeneziaGiulia: "Confini sfumati tra vigneti d'oro", Lazio: "Arte, tradizione culinaria e paesaggi collinari.", Liguria: "La terra dei borghi pittoreschi",
        Lombardia: "Il cuore del nord Italia", Marche: "La regione con un paesaggio collinare armonioso", Piemonte: "Terra di vini pregiati con una forte identità",
        Puglia: "Dove la vita scorre lenta al ritmo del sole", Sicilia: "Storia e sapori, sole e mare", Toscana: "Regione di Arte, storia e paesaggi",
        TrentinoAltoAdige: "Storie di roccia, boschi e libertà", Umbria: "Il cuore verde d'Italia", Veneto: "Regione straordinariamente varia e dinamica",
    }
    const preferiti = (idEvent) => {
        if (idUser && logged) {//se l'utente è loggato
            preferitiTesto.current.style.opacity = '1'
            if (preferitiCuore.current.style.color === 'lightpink') {//AGGIUNGO L'EVENTO AI PREFERITI 
                try {
                    axios.get(`/salvaPreferito/${idEvent}/${idUser}`).then(res => {
                        if (res.data === 'success') {
                            preferitiCuore.current.style.color = 'red'
                            setPrefer('salvato in preferiti')
                            setTimeout(() => {
                                preferitiTesto.current.style.opacity = '0'
                            }, 2000)
                        }
                    })
                } catch (err) { console.log(err) }

            } else {//TOLGO L'EVENTO DAI PREFERITI
                try {
                    axios.get(`/eliminaPreferito/${idEvent}/${idUser}`).then(res => {
                        if (res.data === 'success') {
                            preferitiCuore.current.style.color = 'lightpink'
                            setPrefer('rimosso da preferiti')
                            setTimeout(() => {
                                preferitiTesto.current.style.opacity = '0'
                            }, 2000)
                        }
                    })
                } catch (err) { console.log(err) }
            }

        } else {//UTENTE NON LOGGATO non può salvare gli eventi nei preferiti
            alert('Login obbligatorio. Se non sei loggato devi prima registrarti.')
        }
    }
    const apriBanner = (e, x) => {//e identifica il banner da aprire da genitore a componente
        if (!bannerCorrente) {
            if (e === 'primoArtisti') setTipo(x)
            setSearchParams({ banner: e })
        }
    }
    const dettagliIsOpen = (e, x) => {// per banner da componente a genitore
        setSearchParams({ banner: e }); setTipo(x)
    }
    const piùDescr = (e) => {
        const we = document.getElementById('mostraDescrBtn')
        e.preventDefault()
        const posizioneAttualeScroll = window.scrollY
        if (we.textContent === "Mostra di più") {
            we.innerHTML = '<i>Mostra meno</i>'
            document.getElementById('descr').innerHTML = gestDescr.testoTagliato + '...👉...' + gestDescr.restoDelTesto
            // document.getElementById('descr').className = 'fs-6 d-inline'
            window.scrollTo(0, posizioneAttualeScroll)
        } else {
            we.innerHTML = "<i>Mostra di più</i>"
            document.getElementById('descr').innerHTML = gestDescr.testoTagliato + '...'
        }
    }
    const geoloc = () => {
        const address = evento.città + ' ' + evento.comune + ' ' + evento.indirizzo
        if (isLoaded && !center.lat) {
            const geocoder = new window.google.maps.Geocoder()
            geocoder.geocode({ address: address }, (results, status) => {// questo costruttore si paga
                if (status === "OK") {
                    const lat = results[0].geometry.location.lat()
                    const lng = results[0].geometry.location.lng()
                    setCenter({ ...center, lat: lat, lng: lng })
                } else {
                    console.error("Geocoding failed: " + status)
                }
            })
        }
    }
    useEffect(() => {
        if (evento.descrizione) {
            if (evento.descrizione.length > 1240) {//settaggio 'mostra più' in descrizione
                let indiceTaglioPulito = evento.descrizione.indexOf(' ', 1200)//Trova la posizione del primo spazio vuoto DOPO il carattere 1200
                if (indiceTaglioPulito === -1) { indiceTaglioPulito = evento.descrizione.length }// Controllo di sicurezza: se non ci sono spazi dopo il carattere 1200, taglia alla fine del testo
                const primiCaratteriPuliti = evento.descrizione.slice(0, indiceTaglioPulito)//Estrai i primi caratteri senza tagliare l'ultima parola
                // document.getElementById('descr').className = 'fs-6 d-inline fade-text'
                document.getElementById('descr').innerHTML = primiCaratteriPuliti + '...'
                setGestDescr({ testoTagliato: primiCaratteriPuliti, restoDelTesto: evento.descrizione.slice(indiceTaglioPulito) })
            } else {
                document.getElementById('descr').innerHTML = evento.descrizione + '...'
                document.getElementById('mostraDescrBtn').style.display = 'none'
            }
        }
        const vb = document.getElementById('divCaricIniz')
        setTimeout(() => { vb.style.opacity = '0' }, 500)
        setTimeout(() => { vb.style.display = 'none' }, 1000)
    }, [evento])

    useEffect(() => {
        console.log('bannerCorrente:', bannerCorrente)
        if (bannerCorrente) {//cosa fare quando clicco previous page
            document.body.style.overflow = 'hidden'
        } else { document.body.style.overflow = '' }
    }, [bannerCorrente])

    useEffect(() => {
        const isRefresh = window.performance //intercetto il ricaricamneto della pagina (F5)
            ?.getEntriesByType('navigation')
            ?.[0].type === 'reload'
        if (isRefresh && searchParams.has('banner')) {//rimuovo 'banner' quando ricarico la pagina
            searchParams.delete('banner')
            setSearchParams(searchParams, { replace: true })
        }
    }, [])

    // useEffect(() => { console.log('incorpora:', incorpora) }, [incorpora])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}

        <div style={{ marginTop: '4rem', marginBottom: '3rem' }} id='corpo'>
            <h5 style={{ padding: '5%', textAlign: 'center', width: 'fit-content', margin: '1rem auto' }}>
                Approfitta dell'evento per scoprire e visitare la città di <b>{evento.città}</b> e i borghi incantevoli vicino ad essa.
            </h5>
            <App />
            {/* ------------------------------- DIV VUOTO PER FAR CARICARE L'OGGETTO EVENTO ----------------------- */}
            <div id="divCaricIniz" style={{
                height: '600px', width: '100%', position: 'absolute', zIndex: '1', fontSize: 'large', transition: 'opacity 1s', left: '0', right: '0', top: '26em', margin: 'auto', textAlign: 'center'
            }}>
                <div className='mt-3'>Caricamento...
                    <RotatingLines strokeColor='silver' strokeWidth='5' animationDuration='5' width='26' />
                </div>
            </div>
            {id &&
                <DettagliEvento
                    idEvento={id}
                    onDataSubmit={(e) => { setEvento(e) }}
                    opaco={(e) => { setOpaco(e ? e : 1) }}
                    incorpora={(e) => { setIncorpora(e) }}
                    img={(e) => { setImg(e) }}
                    preferitiCuore={(e) => { if (e === 'red') preferitiCuore.current.style.color = 'red' }} />
            }
            <RispostaAI domanda={domandaAI} flag={bannerCorrente} />
            <AltriEventiRegione
                dettagliIsOpen={dettagliIsOpen} regione={evento.regione} flag={bannerCorrente} flag2={bannerCorrente}
                onChiudi={(e) => { window.location.href = `/eventiDetails/${e}` }} />
            <Ristoranti
                onChiudi={() => { window.history.back() }}
                dettagliIsOpen={dettagliIsOpen}
                flag={bannerCorrente}
                flag2={bannerCorrente}
                flag3={bannerCorrente}
                lat={center.lat}
                lng={center.lng}
                distanza={center.distanza}
                idEvento={evento.id} />
            <Alberghi
                onChiudi={() => { window.history.back() }}
                dettagliIsOpen={dettagliIsOpen}
                flag={bannerCorrente}
                flag2={bannerCorrente}
                flag3={bannerCorrente}
                distanza={center.distanza}
                lat={center.lat}
                lng={center.lng}
                idEvento={evento.id} />
            <AutoNoleggio
                onChiudi={() => { window.history.back() }}
                dettagliIsOpen={dettagliIsOpen}
                flag={bannerCorrente}
                flag2={bannerCorrente}
                flag3={bannerCorrente}
                distanza={center.distanza}
                lat={center.lat}
                lng={center.lng}
                idEvento={evento.id} />

            <CollabArtisti
                dettagliIsOpen={dettagliIsOpen}
                tipo={tipo}
                flag={bannerCorrente}
                flag2={bannerCorrente}
                flag3={bannerCorrente} />
            <Fornitori
                onChiudi={() => { window.history.back() }} dettagliIsOpen={dettagliIsOpen}
                flag={bannerCorrente}
                flag2={bannerCorrente} />
            {evento.id &&
                <Commenti
                    onChiudi={() => { window.history.back() }}
                    email={evento.email}
                    flag={bannerCorrente} idEvento={id}
                    userIdEvento={evento.userId}
                    img={img} titolo={evento.titolo}
                    messaggiLength={(msg) => { setCommentiLength(msg) }}
                    disabledComment={evento.disabledComment}
                    disabledNotificaEmail={evento.disabledNotificaEmail} />
            }

            <div className='divEventiDetails'>
                <DivLeft fb={evento.fb}// div solo per desktop
                    youTube={evento.youTube}
                    url={evento.url}
                    regione={evento.regione}
                    apriBanner={apriBanner} geoloc={geoloc} vaiAMaps={() => { maps.current?.scrollIntoView({ behavior: 'smooth' }) }} />

                <div className='bordo' id='body'>
                    {/* ---------------------------- TITOLO ICONA MESSAGGI ---------------------- */}
                    <div style={{ opacity: opaco }} className='bodyPadding'>
                        <div style={{ padding: '3% 1%' }}>
                            <h1><b>{evento.titolo}</b></h1> <br />
                            <div style={{
                                backgroundColor: 'maroon', padding: '3px 5px', color: 'azure', opacity: '.8', width: 'fit-content',
                                float: 'right', fontSize: '16px', display: 'inline-block', borderRadius: '5px', fontWeight: '600'
                            }}> {evento.tipologia}
                            </div>
                            {/* --------------- icona messaggi ---------------- */}
                            <div style={{ margin: '0 0 0 1rem', fontSize: 'large' }}>
                                {evento.view} view
                                <span style={{ paddingLeft: '2em', cursor: 'pointer' }} onClick={() => { apriBanner('primoMessGenitore') }}>
                                    <img src={require('./image/icons8-fumetti-con-puntini-50.png')} width={'28em'} style={{ backgroundColor: 'white' }} alt='' />
                                    <span style={{ marginLeft: '.6em' }}>
                                        <i>{commentiLength}</i></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    {evento.id &&
                        <div>
                            <div style={{ opacity: opaco, position: 'relative' }} className='bodyPadding'>
                                <h2 style={{ opacity: '1', display: 'inline-block', color: 'forestgreen', margin: '10px 0 0 1rem' }}><b>{evento.regione.toUpperCase()}</b></h2>
                                {/* ------------------- PREFERITI --------------------- */}
                                <div>
                                    <div style={{ margin: '0 20px 0 0', float: 'right' }} onClick={() => { preferiti(evento.id) }}>
                                        {/* <span ref={preferitiCuore} style={{
                                            fontSize: 'xx-large', transition: '.3s', color: 'lightpink', cursor: 'pointer'
                                        }}>❤
                                        </span> */}
                                    </div>

                                    <div style={{ fontFamily: 'roman', margin: '10px 0 0 1rem', color: 'green' }}><i>{regioni[evento.regione.replaceAll(" ", "")]}</i></div>

                                    <div ref={preferitiTesto} style={{
                                        fontSize: 'small', position: 'absolute', right: '14%', top: '4em', border: '1px solid lightseagreen', opacity: '0',
                                        backgroundColor: 'lightcyan', borderRadius: '15px', padding: '5px', fontWeight: '600', transition: 'opacity 2s'
                                    }}>
                                        {prefer}
                                    </div>
                                </div><br />

                                <div>{/* -------------------- IMMAGINI ---------------- */}
                                    {img.length === 1 && //evento con una foto
                                        <div className='text-center'>
                                            <img src={`https://leuro-bucket.s3.amazonaws.com/${img[0]}`} style={{ maxWidth: '100%', height: '500px' }} alt='' />
                                        </div>
                                    }
                                    {img.length > 1 && //evento con almeno 2 foto caricata dall'utente
                                        <div className='galleria_eventiDetails mt-2'>
                                            <img src={`https://leuro-bucket.s3.amazonaws.com/${img[0]}`} className="card-img-top gbox1_eventiDetails" alt='' />
                                            <img src={`https://leuro-bucket.s3.amazonaws.com/${img[1]}`} className="card-img-top gbox1_eventiDetails" alt='' />
                                            {img.length === 3 &&
                                                <img src={`https://leuro-bucket.s3.amazonaws.com/${img[2]}`} className="card-img-top gbox1_eventiDetails accordionHomeMobile"
                                                    alt=' ' />
                                            }
                                        </div>
                                    }
                                    {img.length === 0 && //evento senza foto
                                        <div className='text-center'>
                                            {fotoRandom ? <img src={`https://leuro-bucket.s3.amazonaws.com/imgRandomEventi/${fotoRandom}`} className='rounded' alt=''
                                                style={{ maxWidth: '100%', height: '500px', objectFit: 'cover' }} /> :
                                                <img src={"https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg"} style={{ maxWidth: '100%', height: 'auto' }} alt='' />
                                            }
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className='bodyPadding' style={{ opacity: opaco }}>
                                <div>{/* ------------- STATO EVENTO --------------------*/}
                                    {evento.accettazione === 'null' && //EVENTO ANNULLATO
                                        <h5 style={{ textAlign: 'center', backgroundColor: 'dimgrey', color: 'white', padding: '8px' }}>
                                            EVENTO ANNULLATO
                                            {logged && evento.userId === idUser &&
                                                <p className='fs-6'>Potrai sempre reinserirlo dal menù <i>myEventi</i></p>
                                            }
                                        </h5>
                                    }
                                    {evento.accettazione === 'rejection' && evento.userId === idUser && //EVENTO RIFIUTATO
                                        <h5 style={{ textAlign: 'center', backgroundColor: 'red', color: 'white', padding: '3px' }}>EVENTO RIFIUTATO
                                            {logged && evento.userId === idUser &&
                                                <p className='fs-6'>Modifica i contenuti con testi o immagini più moderate.</p>
                                            }
                                        </h5>
                                    }
                                </div>
                                {evento.sottotitolo && /* ---- SOTTOTITOLO ------ */
                                    <div>
                                        <p ref={parSottotitolo} style={{
                                            textAlign: 'center', padding: '1em 5px', fontSize: '17px', fontWeight: '600'
                                        }}>
                                            {evento.sottotitolo}
                                        </p>
                                    </div>
                                }
                                <div>{/* -------------------- POSIZIONE ---------------------- */}
                                    <h4 className='mt-5'>
                                        <a href='#geoloc' onClick={geoloc}
                                            style={{ textDecoration: 'none', color: 'black' }}>
                                            <img src={require('./image/icons8-visita-24.png')} style={{ margin: '-1px 5px 0 0' }} alt='' />
                                            {evento.comune}
                                        </a>
                                    </h4>
                                    {evento.indirizzo &&
                                        <p style={{ marginLeft: '1rem', marginTop: '-5px', fontSize: 'small' }}>{evento.indirizzo}</p>
                                    }
                                    <p style={{ fontSize: 'large', margin: '-15px 0 0 1rem' }}>{evento.città} ({evento.provincia})</p>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', marginTop: '2em', gap: '18px', fontSize: 'medium' }}>
                                    <button className='btn btn-dark' onClick={() => { apriBanner('primoRistoranti'); geoloc() }}>TROVA RISTORANTI</button>
                                    <button className='btn btn-dark' onClick={() => { apriBanner('primoNoleggi'); geoloc() }}>NOLEGGIA UN AUTO</button>
                                    <button className='btn btn-dark' onClick={() => { apriBanner('primoAlberghi'); geoloc() }}>TROVA UN ALLOGIO</button>
                                </div>

                                {/* -------------------------- DESCRIZIONE ----------------------- */}
                                <div style={{ fontWeight: '500', backgroundColor: '#fffcfc', padding: '20px 10px', borderBottom: '1px solid lightblue', borderTop: '1px solid lightblue', marginTop: '1em' }}>
                                    <p className='text-center fs-2'>{evento.titolo.toUpperCase()}</p>
                                    <p className='fs-6' id="descr" />
                                    <p className='text-center'>
                                        <button onClick={piùDescr} id="mostraDescrBtn" className='fw-semibold'><i>Mostra di più</i></button>
                                    </p>
                                    {/* ---------------------- ALTRI EVENTI ------------------------ */}
                                    <div style={{ color: 'mediumblue', fontSize: '15px', margin: '2em 0 0 1em', cursor: 'pointer' }}>
                                        <u onClick={() => { apriBanner('primoRegioni') }}><b>ALTRI EVENTI IN {evento.regione.toUpperCase()}</b></u>
                                    </div>
                                </div>
                                {/* -------------------------- AGGIUNGI UN EVENTO --------------------------- */}
                                <div className='d-flex justify-content-center mt-5 fs-6'>
                                    <button style={{ backgroundColor: 'navy', color: 'whitesmoke', borderRadius: '5px', width: '57%' }} onClick={() => { navigate('/addEvento') }}>
                                        <b>AGGIUNGI IL TUO EVENTO</b>
                                    </button>
                                </div>
                                {evento.ospiti && <Ospiti ospiti={evento.ospiti} />}

                                {/* ------------------------------ ARTISTI PER EVENTI -------------------------------- */}
                                <div className='d-flex justify-content-center mt-3 fs-6 mb-5'>
                                    <button style={{ backgroundColor: 'navy', color: 'whitesmoke', borderRadius: '5px', width: '57%' }} onClick={() => { apriBanner('primoArtisti', 'artisti') }}>
                                        <b>CERCA ARTISTI PER EVENTI</b></button>
                                </div>

                                {evento.opzioniEvento !== '' && /* -------- OPZIONI EVENTO -------  */
                                    <div>
                                        <OpzioniEvento
                                            opzioniEvento={evento.opzioniEvento}
                                            titolo={evento.titolo}
                                            comune={evento.comune}
                                            provincia={evento.provincia}
                                            indirizzo={evento.indirizzo}
                                            domanda={(e) => { setDomandaAI(e) }}
                                            apriBanner={apriBanner} />
                                    </div>
                                }
                                <Ticket         /* --------------- TICKET ----------------------- */
                                    prezzo={evento.prezzo} opzioniBiglietto={evento.opzioniBiglietto}
                                    oraInizio={evento.oraInizio} dataInizio={evento.dataInizio}
                                    oraFine={evento.oraFine} dataFine={evento.dataFine} url={evento.url}
                                    indirizzo={evento.indirizzo} comune={evento.comune}
                                    provincia={evento.provincia} img={img} città={evento.città} />

                                {/* --------------------------  COLLABORATORI PER EVENTI solo mobile --------------------- */}
                                <div className='iconChatMobile' style={{ color: 'mediumblue', fontSize: '15px', fontWeight: '600', margin: '2em 0 0 1em', cursor: 'pointer' }}>
                                    <p onClick={() => { apriBanner('primoServizi') }}><u>CERCA COLLABORATORI PER EVENTI</u></p>
                                </div>
                                <ServiziRapidi
                                    flag={bannerCorrente}
                                    flag2={bannerCorrente}
                                    flag3={bannerCorrente}
                                    dettagliIsOpen={dettagliIsOpen} />
                                <AddArtista />
                                <div ref={maps}><Geolocation
                                    geoloc={geoloc}
                                    lat={center.lat}
                                    center={center}
                                    isReady={isLoaded}
                                    readyError={loadError} /></div>
                                {/* ------------------------ LINK ----------------------- */}
                                <div style={{ border: '1px solid lightgrey', borderRadius: '15px', padding: '15px 5px', marginTop: '3em' }}>
                                    <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                                    {evento.url &&
                                        <div className='btn btn-warning fw-semibold'>
                                            <a href={evento.url} style={{ textDecoration: 'none', color: 'navy', display: 'inline' }} target='_blank' rel="noopener noreferrer">Sito web</a>
                                        </div>
                                    }
                                    {evento.fb &&
                                        <a href={evento.fb} style={{ textDecoration: 'none', color: 'white', fontSize: 'x-large' }} target='_blank' rel="noopener noreferrer">
                                            <img src={require('./image/icons8-fb-48.png')} alt='' style={{ marginLeft: '1rem' }} />
                                        </a>
                                    }
                                    {evento.youTube &&
                                        <a href={evento.youTube} target='_blank'>
                                            <img src={require('./image/icons8-instagram-48.png')} alt='' style={{ marginLeft: '1rem' }} rel="noopener noreferrer" />
                                        </a>
                                    }
                                    {!evento.url && !evento.fb && !evento.youTube && <span><i>nessun link presente</i></span>}
                                </div>
                                {evento.video && /* --------- VIDEO --------- */
                                    <div style={{ border: '1px solid lightgrey', borderRadius: '5px', padding: ' 15px', marginTop: '6em' }}>
                                        <h5 className='text-center'>VIDEO DELL'EVENTO</h5>
                                        <div className='text-center mt-3'>
                                            <video src={`https://leuro-bucket.s3.amazonaws.com/video/${evento.video}`} id={'videoPreview'}
                                                style={{ width: '99%', maxHeight: '200px', borderRadius: '5px' }} controls />
                                        </div>
                                    </div>
                                }
                                {/* ---------------------- INCORPORA VIDEO -------------------- */}
                                {incorpora && incorpora.length === 11 && (
                                    <div className='mt-4' style={{ width: '100%' }} translate="no">
                                        <iframe style={{ border: '5px solid red', backgroundColor: 'transparent', width: '100%', height: '400px' }}
                                            key={incorpora}
                                            src={`https://www.youtube-nocookie.com/embed/${incorpora}`}
                                            credentialless="true"
                                            title="YouTube Video Player"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen
                                            loading="eager"
                                        ></iframe>
                                    </div>
                                )}

                                <InfoOrganizzatore
                                    telefono={evento.telefono}
                                    email={evento.email}
                                    infoOrganizzatore={evento.infoOrganizzatore}
                                    apriBanner={apriBanner}
                                    messaggiLength={commentiLength} />

                                <BorghiVicini città={evento.città} imgLength={img.length} />

                                <div className='mt-5'>
                                    Zona eventi è anche su <a href='https://www.facebook.com/profile.php?id=61577239793766&locale=it_IT' target='_blank' rel="noopener noreferrer">
                                        facebook</a> e su <a href='https://www.instagram.com/zona_eventi_free/' target='_blank' rel="noopener noreferrer">instagram</a>

                                </div>
                                <button className='btn btn-secondary' style={{ marginTop: '3rem' }} onClick={() => {
                                    navigate(-1)
                                }}>Indietro ⇇</button>
                                <br />
                            </div>
                        </div>
                    }
                    <Luoghi />
                </div>
            </div>
        </div>
        <DivBottom />
    </>
    )
}
export default EventiDetails